var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsFilledChevronRight24Px(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FC68293B-47AD-4747-9299-252164413710") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Filled/chevron-right_24px"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "\\uD83C\\uDF08-Icon-Color"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chevron-right",
    transform: "translate(0.000000, 0.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.44204566,8.61994521 L2.34272146,15.7192329 C2.00032877,16.0616256 1.44522374,16.0616256 1.10286758,15.7192329 L0.274849315,14.8912146 C-0.0669589041,14.5494064 -0.0676164384,13.9954338 0.273388128,13.6528219 L5.89972603,8 L0.273388128,2.34721461 C-0.0676164384,2.00460274 -0.0669589041,1.45063014 0.274849315,1.10882192 L1.10286758,0.280803653 C1.44526027,-0.0615890411 2.0003653,-0.0615890411 2.34272146,0.280803653 L9.44200913,7.38009132 C9.78440183,7.72244749 9.78440183,8.27755251 9.44204566,8.61994521 Z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsFilledChevronRight24Px);
export default __webpack_public_path__ + "static/media/Icons_Filled_chevron-right_24px.2e418e44.svg";
export { ForwardRef as ReactComponent };